import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as NonHumanIdentityIconSvg } from "./nonhuman_identity_icon.svg";

export default function NonhumanIdentityIcon(props) {
  return (
    <SvgIcon {...props}>
      <NonHumanIdentityIconSvg />
    </SvgIcon>
  );
}
